// extracted by mini-css-extract-plugin
module.exports = {"baseGrid":"TabMain_baseGrid__AUVY0","heading":"TabMain_heading__tArzs","cardList":"TabMain_cardList__XxIHw","tabMain":"TabMain_tabMain__IpaEg TabMain_baseGrid__AUVY0"};